import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of } from 'rxjs';

// Preloads every lazy route except ones flagged `data: { preload: false }` (PCIS-11524).
// PreloadAllModules was blanket-preloading every feature module - including the
// Power BI/report-heavy people/details module - into every open tab regardless of
// which page it's on, inflating background tabs' memory footprint (e.g. the
// Dashboard tab) and making the browser more likely to discard them under memory
// pressure when another tab has a live report open. This keeps the same
// preload-everything-by-default behavior PCIS-10663 relied on, just opting the
// heaviest routes out individually instead of reverting preloading app-wide.
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (route.data && route.data.preload === false) {
      return of(null);
    }
    return load();
  }
}
